import { envConfig } from '#constants/envConfig';

export const GTM = { id: envConfig.GA_ID };
